/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedTrackingContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedLayout_user$ref: FragmentReference;
export type PdpSharedLayout_user = {|
  +$fragmentRefs: SharedTrackingContainer_user$ref,
  +$refType: PdpSharedLayout_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedLayout_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4d055eca3cf7a8b680bf82157ea283dc';
module.exports = node;
